export const environment = {
  production: false,
  // captchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  // captchaKeyV3: '6LdFBsQZAAAAAMo_ZRBrPUCKLqykw6Zt8RDwW2c1',
  urlServices: 'https://leonisavirtualtest.leonisa.com/pos-service/service/',
  urlServiceExitoRDLCore: 'https://us-central1-retaildigitalleonisa20.cloudfunctions.net/api/cddata/',
  PUBLIC_KEY: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAh/0w+BmJiVgW6CKsnHEkDpQJwRtJzqOT7V0zwaLcWbEI46877DU4vfRI3SnPIXtfuPqjvmGFrOp8rRSrqYeR9/CASldEPRfr5RSq812ukcoQdVgrE0mRzJlfFVOHMYudGNboM70b+w5sR9yqOwtDZbIl3cjH4RrYQ5+uxP0VpEFEQsckExFzv3ZQ/cooE38PRf4kpjQaBMTWh6AOBQgZ6EzW9SCOzbmj3DP6eM9bBUVzjsu9vj1i/yF9vyHYv3uhuX15E4WatJBrWboeNWY8nH0a/ibZ3HDAX1LmTLvyH2JgM7DD2oyENbe7EXgnEYT4Q9qBdhbAkMlS3YMf4a4wVwIDAQAB',
  // appidOneSignal: 'aa3bfb00-0dea-4d44-8fea-b31a69db2223',
  textVersion: 'TEST',
  AUTHSERVICE_PATH: 'https://srvappsha.leonisa.com/Aplicativos_Informaticos/authservice/api/v2',
  VERSION: 'Versión test',
  FIREBASE_RDB:  {
    apiKey: "AIzaSyDw2FJtMqif8_8aG1B_jRiwGAKO8cz3zYc",
    authDomain: "apileonisa-rfid.firebaseapp.com",
    databaseURL: "https://apileonisa-rfid-default-rtdb.firebaseio.com",
    projectId: "apileonisa-rfid",
    storageBucket: "apileonisa-rfid.appspot.com",
    messagingSenderId: "993614667257",
    appId: "1:993614667257:web:7dfcd97da8041cc9817128"
  }
};



